import { useState } from 'react';
import { usePracticeListQuery } from '@common/cache';
import { usePracticeTableStore } from '../Filters/filters.store';
import { useDrawerStore } from 'store/drawer.store.ts';

export const usePractice = () => {
  const { filters } = usePracticeTableStore();
  const [isCreatePracticeModalOpen, setIsCreatePracticeModalOpen] =
    useState(false);
  const [isImportPracticeModalOpen, setIsImportPracticeModalOpen] =
    useState(false);
  const [selectedPracticeId, setSelectedPracticeId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = {
      count: 0,
      records: [],
    },
    isRefetching,
    isLoading,
  } = usePracticeListQuery(filters);

  const entries = data.records;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedPracticeId('');
  };

  const handleOpenPracticeDetails = (id: string) => {
    setSelectedPracticeId(id);
    setDrawerOpen(true);
  };

  const handleOpenCreatePracticeModal = () => {
    setIsCreatePracticeModalOpen(true);
  };

  const handleCloseCreatePracticeModal = () => {
    setIsCreatePracticeModalOpen(false);
  };

  const handleOpenImportPracticeModal = () => {
    setIsImportPracticeModalOpen(true);
  };

  const handleCloseImportPracticeModal = () => {
    setIsImportPracticeModalOpen(false);
  };

  return {
    entries,
    totalCount: data.count,
    isInitialFilters:
      filters.search === '' &&
      filters.partner_id === '' &&
      filters.state === '',
    isLoading: isLoading || isRefetching,
    handleCloseDrawer,
    handleOpenPracticeDetails,
    isDrawerOpen,
    selectedPracticeId,
    handleOpenCreatePracticeModal,
    handleCloseCreatePracticeModal,
    handleOpenImportPracticeModal,
    handleCloseImportPracticeModal,
    isCreatePracticeModalOpen,
    isImportPracticeModalOpen,
  };
};
